// services/api.js
// export const API_BASE = "http://localhost:8000/api";
export const API_BASE = "https://edcbackend.lsc-india.org/api";


//  POST function
export const postData = async (endpoint, payload) => {
  const res = await fetch(`${API_BASE}/${endpoint}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await res.json();

  // Return the data along with the status code
  return { data, status: res.status };
};



// course GET function
export const getCourse = async (endpoint) => {
    try {
        const res = await fetch(`${API_BASE}/${endpoint}`);
        const data = await res.json();
        if (!res.ok) throw data;
        return data;
    } 
    catch (error) {
        throw error;
    }
};



// Category GET function
export const getCategory=async (endpoint)=>{
    try{
        const res= await fetch(`${API_BASE}/${endpoint}`)
        const data = await res.json();
         if (!res.ok) throw data;
        return data;
    }
    catch(err){
         throw err;

    }
}

export const loginData = async (endpoint, payload) => {
    // const csrf = await getCsrfToken();
  try {
    const res = await fetch(`${API_BASE}/${endpoint}`, {
      method: "POST",
      credentials: "include",
      headers: { 
        "Content-Type": "application/json",
        //  "X-CSRF-TOKEN": csrf,
        
       },
      body: JSON.stringify(payload),
    });

    const raw = await res.text(); // read body once
    let data;

    try {
      data = JSON.parse(raw); // try parsing JSON
    } catch {
      data = { message: "Too many attempts" }; // fallback for HTML
    }

    if (!res.ok) {
      const message = data?.message || `Error: ${res.status}`;
      const error = new Error(message);
      error.status = res.status;
      error.retryAfter = res.headers.get("Retry-After"); // useful for 429
      throw error;
    }

    return data;
  } catch (error) {
    throw error; // now toast can access error.message
  }
};

export const getCsrfToken = async () => {
  const res = await fetch(`${API_BASE}/csrf-token`, {
    method: "GET",
    credentials: "include",
  });
  const data = await res.json();
  return data.csrf_token;
};




//get course by id 

export const getCourseById = async (id) => {
  try {
    const res = await fetch(`${API_BASE}/getcourse/${id}`, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
      credentials: "include",
    });

    const data = await res.json();
    if (!res.ok) throw data;

    return data.course; // <-- correct return
  } catch (err) {
    console.error("getCourseById error", err);
    throw err;
  }
};


//get user

export const getUser = async () => {
  try {
    const response = await fetch(`${API_BASE}/user`, {
      method: 'GET',
      credentials: 'include', 
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user data');
    }

    return await response.json();
  } catch (error) {
    console.error('Error fetching user:', error);
    throw error;
  }
};



// Logout and clear cookie
export const logoutUser = async () => {
  try {
    const res = await fetch(`${API_BASE}/logout`, {
      method: "POST",
      credentials: "include", // Include the cookie for backend to clear
    });
    const data = await res.json();
    if (!res.ok) throw data;
    return data;
  } catch (error) {
    throw error;
  }
};



export const getEnrolledCourses = async () => {
  try {
    const res = await fetch(`${API_BASE}/user/enrolled-courses`, {
      method: "GET",
      credentials: "include", // important for session auth
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.json();
    if (!res.ok) throw data;
    return data; // [{ id: 12, moodle_course_id: 55 }, ...]
  } catch (error) {
    console.error("Error fetching enrolled courses:", error);
    throw error;
  }
};



// Search Courses
export const searchCourses = async (query) => {
  try {
    const res = await fetch(`${API_BASE}/search-courses?q=${encodeURIComponent(query)}`);
    const data = await res.json();
    if (!res.ok) throw data;
    return data.results;
  } catch (error) {
    console.error("Error searching courses:", error);
    throw error;
  }
};


// Refresh Token API
export const refreshToken = async () => {
  try {
    const res = await fetch(`${API_BASE}/refresh-token`, {
      method: "POST",
      credentials: "include", 
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.json();
    if (!res.ok) throw data;
    return data; // e.g., { status: true, message: "Access token refreshed" }
  } catch (error) {
    console.error("Error refreshing token:", error);
    throw error;
  }
};





// --------------------------------------------------------------------------------

// Batch course API (categories + courses + enrolled)
export const getCourseBatch = async (categoryId = null) => {
  try {
    const url = categoryId
      ? `${API_BASE}/course-batch?category=${categoryId}`
      : `${API_BASE}/course-batch`;

    const res = await fetch(url, {
      method: "GET",
      credentials: "include", // include cookies (auth)
      headers: {
        "Content-Type": "application/json",
      },
    });

    const data = await res.json();
    if (!res.ok) throw data;
    return data; // { categories: [...], courses: [...], enrolled_courses: [...] }
  } catch (error) {
    console.error("Error fetching batch courses:", error);
    throw error;
  }
};


//forget password
export const resetPassword = async (data) => {
  try {
    const res = await fetch(`${API_BASE}/reset-password`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await res.json();

    // If server returns error response
    if (!res.ok) {
      return result; 
    }

    return result; 
  } catch (error) {
    throw error;
  }
};

export const accessReset = async (id) => {
  try {
    const response = await fetch(`${API_BASE}/reset-token-verify/${id}`, {
      method: "GET",
    });

    // Parse JSON response
    const data = await response.json();

    // Return success or error structure
    return data;

  } catch (err) {
    console.error("Error:", err);
    return { status: false, message: "Something went wrong!" };
  }
};
